export default "__VITE_ASSET__RrKAi9EU__"